<template>
  <div>
    <headPage></headPage>
    <div style="border-bottom: 1px solid #eee; margin-bottom: 10px"></div>
    <div style="padding: 20px 0; width: 600px; margin: 0 auto">
      <el-steps :active="isPage">
        <el-step title="填写申请信息" description=""></el-step>
        <el-step title="付款" description=""></el-step>
        <el-step title="开立保函" description=""></el-step>
      </el-steps>
    </div>
    <!-- 填写申请 -->
    <beginPage v-if="isPage == 0" @submitForm="submitForm(1)"></beginPage>
    <!-- 付款/开立保函 -->
    <paymentPage v-else></paymentPage>
    <!-- 开立保函 -->
    <!-- <overPage v-if="isPage == 2"></overPage> -->
  </div>
</template>

<script>
import headPage from '@/components/head/index.vue'
import beginPage from './begin.vue'
import paymentPage from './payment.vue'
export default {
  components: { headPage, beginPage, paymentPage },
  data() {
    return {
      isPage: 0 // 0填写申请信息 1付款信息  2开立保函
    }
  },
  mounted() {
    this.isPage = this.$route.query.type ? Number(this.$route.query.type) : 0
  },
  methods: {
    submitForm(v) {
      console.log(v)
      this.isPage = 1
    }
  }
}
</script>

<style scoped lang="scss"></style>
